export const OverviewEntryTypes = {
  STRING: 'STRING',
  DATE: 'DATE',
  CURRENCY: 'CURRENCY'
}
